import { forwardRef } from 'react'
import { FieldGroup, FieldGroupProps, SuperAdminInfo } from '@/ui'

export const SuperAdminFieldGroup = forwardRef<HTMLDivElement, FieldGroupProps>(function SuperAdminFieldGroup({
  ...rest
}) {
  return <FieldGroup extraRight={<SuperAdminInfo />} {...rest} />
})
